var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "introVideosContent"
  }, [_c('swiper', {
    ref: "introVideosCustomizerSwiper",
    staticClass: "introVideoSwiper",
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "transitionEnd": _vm.onTouchEnd,
      "slideChange": _vm.onSwiperSlideChange
    }
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('video', {
      ref: 'step' + index,
      refInFor: true,
      attrs: {
        "playsinline": "",
        "autoplay": "",
        "muted": ""
      },
      domProps: {
        "muted": true
      },
      on: {
        "ended": _vm.onVideoEnded
      }
    }, [_c('source', {
      attrs: {
        "src": "",
        "type": "video/mp4"
      }
    })])]);
  }), 1), _c('div', {
    staticClass: "introVideosArrows"
  }, [_c('button', {
    staticClass: "button-carrousel",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open",
    attrs: {
      "slot": "button-previous"
    },
    slot: "button-previous"
  })]), _c('div', {
    staticClass: "introVideosText"
  }, [_c('p', [_vm._v(_vm._s(_vm.translations[_vm.currentStep.description]))]), _c('div', {
    staticClass: "swiper-pagination-ugc-introvideos",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })]), _c('button', {
    staticClass: "button-carrousel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onRightClick
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }